import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Index } from "ducks/Index/index";

export default function IndexPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Savant Power"}</title>
      </Helmet>
      {createElement(Index, props)}
    </Fragment>
  );
}
